import { Row, Col, Container, Card, Button, Table, Dropdown, Spinner, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import formatCurrency from "../../utils/currencyFormmter";
import { useNavigate } from "react-router-dom";
import { assignOrderToDepartment, getAllDepartments, getAllOrders, getOrderAnalytics, manageOrder, orderAnalyticsChart, orderAnalyticsChartDownload } from "../../redux/slices/inventory.slice";
import dateFormatter from "../../utils/dateFormatter";
import RecordFilter from "../../components/RecordFilter";
import InventoryConnectionButton from "../../components/InventoryConnector";
import InventoryConnection from "../../components/InventoryConnection";
import { Bar } from "react-chartjs-2";


const Orders = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoaded = useRef(false)
    const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


    const initialState = {
        loading: false,
        show_vendor_form: false,
        showStockForm: false,
        showForm: false,
        showChart: false,
        analytics: {},
        paginationData: {next: '', prev: ''},
        payload: {
            amount: 1,
            page: 1,
            from_date: '',
            to_date: '',
            status: '',
            filter_by: '',
            sort_by: '',
            filter: '',
        },
        errors: {},
        suppliers: [],
        products: [],
        restockMode: false,
        product: {},
        pricelist: [],
        orders: [],
        showOrder: false,
        order: {},
        departments: [],
        orderAssignments: {},
        chartData: [],
        showDepartments: false,
        departmentChartData: {},
        showDepartmentChart: false,
    }

    const [state, setState] = useState(initialState)

    const { invLogin } = useSelector((state) => state.inventory)
    const { user } = useSelector((state) => state.auth)
    const { business } = useSelector((state) => state.user)

    const data = {
        labels: labels,
        datasets: state.chartData
    }

    const departmentData = {
        labels: state.departmentChartData?.original?.labels,
        datasets: state.departmentChartData?.original?.datasets
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                display: true
            },
        },
        scales: {
            x: {
                grid: { display: false },
            },
            y: {
                grid: { display: true },
            },
        }
    };

    const departmentOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                display: false
            },
        },
        scales: {
            x: {
                grid: { display: false },
            },
            y: {
                grid: { display: true },
            },
        }
    };

    useEffect(() => {
        if(invLogin && !isLoaded.current) {
            loadAnalytics()
            loadOrders()
            isLoaded.current = true
            loadDepartments()
            loadChartAnalytics()
        }
    }, [invLogin, state.payload.page])

    const orderManagement = (item, option) => {
        const selectedOption = option === 'cancelled' ? 'Cancel' : (option === 'closed' ? 'Close' : option) 
        Swal.fire({
            icon: "warning",
            text: `Are you sure you want to ${selectedOption} this order?`,
            showCancelButton: true,
            showConfirmButton: true,
        })
        .then((result) => {
            if(result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true}))
                dispatch(manageOrder({ order_id: item.id, status: option}))
                .then((response) => {
                    if(response.payload?.status === true) {
                        loadOrders()
                        Swal.fire({
                            icon: 'success',
                            text: response.payload?.message || 'An error occured'
                        })
                    }
                    else if(response.payload?.status === false) {
                        Swal.fire({
                            icon: 'error',
                            text: response.payload?.message || 'An error occured'
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false})))
            }
        })
    }

    const handleInput = (event) => {
        const {name, value} = event.target
         if(name === 'amount') {
            const newValue = parseFloat(value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'));
            setState((prevState) => ({...prevState, payload: { ...prevState.payload, [name]: newValue}}))
        }
        else {
            setState((prevState) => ({...prevState, payload: { ...prevState.payload, [name]: value}}))
        }
    }
    
    const handlePagination = (data) => {
        isLoaded.current = false
        setState((prevState) => ({...prevState, payload: {...prevState.payload,  page: data}}))
    }

    const loadAnalytics = () => {
        dispatch(getOrderAnalytics())
        .then((response) => {
            if(response.payload?.data) {
                setState((prevState) => ({...prevState,  analytics: response.payload.data}))
            }
        })
    }

    const loadOrders = () => {
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(getAllOrders(state.payload))
        .then((response) => {
            if(response?.payload?.status === true) {
                const result = response.payload?.data?.data
                // setState((prevState) => ({...prevState, orders: result}))
                const pagination = {
                    next: response?.payload?.data?.next_page_url,
                    prev: response?.payload?.data?.prev_page_url,
                }
                setState((prevState) => ({...prevState, paginationData: pagination, orders: result}))
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const handleSearch = () => {
        loadOrders()
    }

    const handleShowOrder = (item) => {
        setState((prevState) => ({...prevState, order: item, showOrder: true}))
    }

    const handlePrint = (order) => {
    
        const receiptContent = `
            <div class="header">
                <img src="${business?.profile_image}" alt="Company Logo" class="logo" width="70">
                <h1>${business?.store_name}</h1>
                <p>${business?.store_address}</p>
                <p>Phone: ${business?.phone_number}</p>
            </div>
            
            <div class="receipt-info">
                <p><strong>Order #:${order.order_number}</strong></p>
                <p>Date: ${dateFormatter(order.created_at)}</p>
            </div>
            
            <table>
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    ${order.items.map(
                        (item) => `
                        <tr>
                            <td>${item.product_name}</td>
                            <td>${formatCurrency(item.quantity).formatted}</td>
                            <td>${formatCurrency(item.sales_price).with_currency}</td>
                            <td>${formatCurrency(item.sales_price * item.quantity).with_currency}</td>
                        </tr>
                        `
                    ).join("")}
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="3">Subtotal</td>
                        <td>${formatCurrency(order.amount).with_currency}</td>
                    </tr>
                    <tr>
                        <td colspan="3">VAT</td>
                        <td>${formatCurrency(order.vat).with_currency}</td>
                    </tr>
                    <tr>
                        <td colspan="3">Consumption Tax</td>
                        <td>${formatCurrency(order.consumption_tax).with_currency}</td>
                    </tr>
                    <tr class="total">
                        <td colspan="3"><strong>Total</strong></td>
                        <td><strong>${formatCurrency(order.total).with_currency}</strong></td>
                    </tr>
                </tfoot>
            </table>
            
            <div class="footer">
                <p>Thank you for your purchase!</p>
            </div>
        `;
    
        const printWindow = window.open("", "", "width=450,height=600");
        printWindow.document.write(`
            <html>
                <head>
                    <title>Receipt - ${order.order_number}</title>
                    <style>
                        body {
                            font-family: 'Courier New', monospace;
                            margin: 20px;
                            max-width: 300px;
                            font-size: 14px;
                            line-height: 1.4;
                        }
                        .header {
                            text-align: center;
                            border-bottom: 2px dashed #000;
                            padding-bottom: 10px;
                            margin-bottom: 10px;
                        }
                        .logo {
                            max-width: 100px;
                            margin: 0 auto;
                            display: block;
                        }
                        h1 {
                            font-size: 20px;
                            margin: 10px 0;
                        }
                        .receipt-info {
                            margin: 10px 0;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                        }
                        th, td {
                            padding: 5px;
                            text-align: left;
                        }
                        th {
                            background-color: #f0f0f0;
                            border-bottom: 2px solid #000;
                        }
                        td {
                            border-bottom: 1px dotted #666;
                        }
                        tfoot td {
                            padding-top: 10px;
                        }
                        .total {
                            font-weight: bold;
                            border-top: 2px solid #000;
                        }
                        .footer {
                            text-align: center;
                            border-top: 2px dashed #000;
                            padding-top: 10px;
                            margin-top: 10px;
                        }
                        .center-all {
                            margin: 0 auto;
                            text-align: center;
                        }
                    </style>
                </head>
                <body>
                    <div class="center-all">
                        ${receiptContent}
                    </div>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    }

    const handleDownload = async (order) => {
        const receiptContent = `
            <div class="receipt-container">
                <div class="header">
                    <img src="${business?.profile_image}" alt="Company Logo" class="logo" width="70">
                    <h1>${business?.store_name}</h1>
                    <p>${business?.store_address}</p>
                    <p>Phone: ${business?.phone_number}</p>
                </div>
                
                <div class="receipt-info">
                    <p><strong>Order #:${order.order_number}</strong></p>
                    <p>Date: ${dateFormatter(order.created_at)}</p>
                </div>
                
                <table>
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${order.items.map(
                            (item) => `
                            <tr>
                                <td>${item.product_name}</td>
                                <td>${formatCurrency(item.quantity).formatted}</td>
                                <td>${formatCurrency(item.sales_price).with_currency}</td>
                                <td>${formatCurrency(item.sales_price * item.quantity).with_currency}</td>
                            </tr>
                            `
                        ).join("")}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3">Subtotal</td>
                            <td>${formatCurrency(order.amount).with_currency}</td>
                        </tr>
                        <tr>
                            <td colspan="3">VAT</td>
                            <td>${formatCurrency(order.vat).with_currency}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Consumption Tax</td>
                            <td>${formatCurrency(order.consumption_tax).with_currency}</td>
                        </tr>
                        <tr class="total">
                            <td colspan="3"><strong>Total</strong></td>
                            <td><strong>${formatCurrency(order.total).with_currency}</strong></td>
                        </tr>
                    </tfoot>
                </table>
                
                <div class="footer">
                    <p>Thank you for your purchase!</p>
                </div>
            </div>
        `;
    
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        tempDiv.style.width = '80mm'; 
        tempDiv.innerHTML = `
            <html>
                <head>
                    <style>
                        body {
                            font-family: 'Courier New', monospace;
                            margin: 0;
                            padding: 5mm;
                            font-size: 12px;
                            line-height: 1.4;
                            width: 80mm;
                        }
                        .receipt-container {
                            width: 100%;
                        }
                        .header {
                            text-align: center;
                            border-bottom: 1px dashed #000;
                            padding-bottom: 5mm;
                            margin-bottom: 5mm;
                        }
                        .logo {
                            max-width: 30mm;
                            margin: 0 auto;
                            display: block;
                        }
                        h1 {
                            font-size: 16px;
                            margin: 2mm 0;
                        }
                        .receipt-info {
                            margin: 3mm 0;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 5mm 0;
                        }
                        th, td {
                            padding: 2mm;
                            text-align: left;
                        }
                        th {
                            background-color: #f0f0f0;
                            border-bottom: 1px solid #000;
                        }
                        td {
                            border-bottom: 1px dotted #666;
                        }
                        tfoot td {
                            padding-top: 3mm;
                        }
                        .total {
                            font-weight: bold;
                            border-top: 1px solid #000;
                        }
                        .footer {
                            text-align: center;
                            border-top: 1px dashed #000;
                            padding-top: 5mm;
                            margin-top: 5mm;
                        }
                    </style>
                </head>
                <body>
                    ${receiptContent}
                </body>
            </html>
        `;
        
        document.body.appendChild(tempDiv);
    
        try {
            // Load libraries
            const { jsPDF } = await import('jspdf');
            const html2canvas = await import('html2canvas');
            
            // Use html2canvas to capture the content
            const canvas = await html2canvas.default(tempDiv, {
                scale: 2,
                logging: false,
                useCORS: true,
                allowTaint: true,
                width: tempDiv.offsetWidth,
                height: tempDiv.scrollHeight,
                windowWidth: tempDiv.scrollWidth
            });
            
            // Create PDF with proper dimensions
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, tempDiv.scrollHeight / 4] // Dynamic height based on content
            });
            
            // Add image to PDF
            const imgData = canvas.toDataURL('image/png');
            const pdfWidth = pdf.internal.pageSize.getWidth() - 10; // 5mm margin on each side
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            
            pdf.addImage(imgData, 'PNG', 5, 5, pdfWidth, pdfHeight);
            
            // Save the PDF
            pdf.save(`Receipt_${order.order_number}.pdf`);
            
        } catch (error) {
            console.error('Error generating PDF:', error);
            // Fallback to print method
            const printWindow = window.open("", "", "width=400,height=600");
            printWindow.document.write(`
                <html>
                    <head>
                        <title>Receipt - ${order.order_number}</title>
                        <style>
                        </style>
                    </head>
                    <body>
                        ${receiptContent}
                    </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.print();
        } finally {
            document.body.removeChild(tempDiv);
        }
    }

    const loadDepartments = () => {
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(getAllDepartments())
        .then((response) => {
            if(response.payload?.status === true) {
                setState((prevState) => ({...prevState, departments: response?.payload?.data}))
            } 
            else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response.payload?.message || 'Could not fetch departments',
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const saveOrderChanges = () => {
        const assignments = state.order.items.map(item => ({
            item_id: item.id,
            department: state.orderAssignments[item.id] ?? item.department
        }));

        setState((prevState) => ({...prevState, loading: true}))
        dispatch(assignOrderToDepartment({id: state.order.id, assignments: assignments}))
        .then((response) => {
            if(response.payload?.status === true) {
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message || 'Successful',
                })
            } 
            else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response.payload?.message || 'Could not fetch departments',
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const handleSelection = (orderItemId, department) => {
        setState((prevState) => ({...prevState, orderAssignments: {...prevState.orderAssignments, [orderItemId]: department}}))
    }

    const downloadReport = () => {
        dispatch(orderAnalyticsChartDownload(state.payload))
        .then((response) => {
            if(response.type === "/storefront/orders/export-reports") {
                Swal.fire({
                    icon: 'success',
                    title: 'Download started',
                    text: 'Your report is being downloaded',
                })
            }
        })
    }

    const loadChartAnalytics = () =>  {
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(orderAnalyticsChart())
        .then((response) => {
            if(response.payload?.orders) {
                setState((prevState) => ({...prevState, 
                    chartData: response.payload.orders?.datasets,
                    departmentChartData: response.payload?.departments, //?.original?.datasets,
                }))
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <InventoryConnectionButton />
                {/* <InventoryConnection /> */}
                <Col md={12} className="row align-items-center justify-content-between flex-wrapd">
                    <div className="col-md-4">
                        <h3 className="m-0">Orders</h3>
                        <p>
                            <small>Manage storefront orders and view overal analytics</small>
                        </p>                        
                    </div>
                    <div className="col-md-8 text-right">
                        <Button 
                            type="button" 
                            className="border-0 mb-2 px-3 ms-2"
                            onClick={ () => navigate(user?.user_type === 'owner' ? '/inventory/storefront/products' : '/members/inventory/storefront/products')}
                        >
                            <FontAwesomeIcon icon={'box-open'}/>
                            <span className="ps-2">Products</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            className="border-0 mb-2 ms-2"
                            onClick={ () => setState((prevState) => ({...prevState, showDepartments: true}))}
                        >
                            <FontAwesomeIcon icon={'store'} />
                            <span className="ps-2">Departments</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            className="border-0 mb-2 ms-2"
                            onClick={ () => navigate( user?.user_type === 'owner' ? '/inventory/storefront' : '/members/inventory/storefront')}
                        >
                            <FontAwesomeIcon icon={'shop'} />
                            <span className="ps-2">Storefront</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="secondary" 
                            className="border-0 mb-2 ms-2 text-white"
                            onClick={ () => navigate(user?.user_type === 'owner' ? '/inventory/sell' : '/members/inventory/sell')}
                        >
                            <FontAwesomeIcon icon={'line-chart'} />
                            <span className="ps-2">Sell Product</span>
                        </Button>
                    </div>
                </Col>

                <div className="mt-4">
                    <Row className="data-card mb-4">
                        <Col md={3} sm={12} className="mb-2">
                            <Card className="border-0 shadow-sm bg--dark rounded-14">
                                <Card.Body className="align-items-center gap-3 p-3">
                                    <p className="text-muted font-bold">Total Orders</p>
                                    <div className="mb-2">
                                        <h3 className="font-bold">{formatCurrency(state.analytics?.total_orders).formatted}</h3>
                                    </div>
                                    <span className="currency-wrapper">
                                        All-time Order
                                    </span>
                                </Card.Body>
                            </Card> 
                        </Col>
                        <Col md={3} sm={12} className="mb-2">
                            <Card className="border-0 shadow-sm bg--dark rounded-14">
                                <Card.Body className="align-items-center gap-3 p-3">
                                    <p className="text-muted font-bold">Total Sales</p>
                                    <div className="mb-2">
                                        <h3 className="font-bold">{formatCurrency(state.analytics?.total_order_amount).with_currency}</h3>
                                    </div>
                                    <span className="currency-wrapper">
                                        All-time Sales
                                    </span>
                                </Card.Body>
                            </Card> 
                        </Col>
                        <Col md={3} sm={12} className="mb-2">
                            <Card className="border-0 shadow-sm bg--dark rounded-14">
                                <Card.Body className="align-items-center gap-3 p-3">
                                    <p className="text-muted font-bold">Orders Today</p>
                                    <div className="mb-2">
                                        <h3 className="font-bold">{ formatCurrency(state.analytics?.daily_orders).formatted }</h3>
                                    </div>
                                    <span className="currency-wrapper">
                                       Orders Today
                                    </span>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} sm={12} className="mb-2">
                            <Card className="border-0 shadow-sm bg--dark rounded-14">
                                <Card.Body className="align-items-center gap-3 p-3">
                                    <p className="text-muted font-bold">Sales Today</p>
                                    <div className="mb-2">
                                        <h3 className="font-bold">{ formatCurrency(state.analytics?.daily_order_amount).with_currency }</h3>
                                    </div>
                                    <span className="currency-wrapper">
                                       Sales Today
                                    </span>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="mb-4 align-items-center justify-content-between">
                        <div className="col-md-5">
                            <h5 className="mb-2">Search Order listing</h5>
                        </div>
                        <div className="">
                            <RecordFilter
                                handleInput={handleInput}
                                handleSearchSubmit={handleSearch}
                                params={[
                                    {label: 'Status', value: 'order_status'},
                                    {label: 'Order Number', value: 'order_number'},
                                    {label: 'Payment Method', value: 'payment_method'},
                                    {label: 'Payment Status', value: 'payment_status'},
                                    {label: 'Date', value: 'date'},
                                ]}
                            />
                        </div>
                    </Row>
                    
                    <Col md={12} sm={12} className="mt-3 mb-3">
                        <Card className="border-0 shadow-sm rounded-14">
                            <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                                Order Chart By Department
                                <Button 
                                    type="button" 
                                    variant="light" 
                                    size="sm"
                                    onClick={() => setState((prevState) => ({...prevState, showDepartmentChart: !state.showDepartmentChart}))}
                                >
                                    {!state.showDepartmentChart ? 'Show Chart' : 'Hide Chart'}
                                </Button>
                            </Card.Header>
                            {
                                state.showDepartmentChart &&
                                    <Card.Body>
                                        <div className="h-100" id="pdf-content">
                                            <Bar data={departmentData} options={departmentOptions} />
                                        </div>
                                    </Card.Body>
                            }
                        </Card>
                    </Col>

                    <Col md={12} sm={12} className="mt-3 mb-3">
                        <Card className="border-0 shadow-sm rounded-14">
                            <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                                Order Chart
                                <Button 
                                    type="button" 
                                    variant="light" 
                                    size="sm"
                                    onClick={() => setState((prevState) => ({...prevState, showChart: !state.showChart}))}
                                >
                                    {!state.showChart ? 'Show Chart' : 'Hide Chart'}
                                </Button>
                            </Card.Header>
                            {
                                state.showChart &&
                                    <Card.Body>
                                        <div className="h-100" id="pdf-content">
                                            <Bar data={data} options={options} />
                                        </div>
                                    </Card.Body>
                            }
                        </Card>
                    </Col>
                    
                    <Card className="border-0 shadow-sm rounded-14">
                        <Card.Header className="bg-primary text-white d-flex justify-content-between">
                            Order History
                            <div className="justify-content-end">
                                <input  
                                    type="date" 
                                    name="from_date" 
                                    className="form-control-sm" 
                                    onChange={handleInput}   
                                />
                                <input 
                                    type="date" 
                                    name="to_date" 
                                    className="form-control-sm" 
                                    placeholder="To Date" 
                                    onChange={handleInput}
                                />
                                <Button 
                                    type="button" 
                                    variant="primary text-white" 
                                    onClick={downloadReport}
                                > Download Report <FontAwesomeIcon icon={'cloud-download'}/> 
                                </Button>
                            </div>
                        </Card.Header>
                        <Card.Body className="table-responsive-lg">
                            <Table size="sm" className="table-color table-striped">
                                    <thead>
                                        <tr>
                                            <th>Order Number</th>
                                            <th>Created By</th>
                                            <th>Order Date</th>
                                            <th>Total Amount</th>
                                            <th>VAT</th>
                                            <th>Payment Method</th>
                                            <th>Order Status</th>
                                            <th>Payment Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody className="data-container">
                                        {
                                            state.loading ? (
                                                <tr className="in-page-loader">
                                                    <td colSpan={8}>
                                                        <Spinner size="lg" variant="primary"/>
                                                    </td>
                                                </tr>
                                            ) : null
                                        }
                                        {
                                            state.orders?.length ? (
                                                state.orders?.map((item, index) => (
                                                    <tr key={item.id}> 
                                                        <td>
                                                            {index + 1}.
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-plain text-primary font-bold"
                                                                onClick={() => navigate(user?.user_type === 'owner' ? `/storefront/orders/${item.id}` : `/members/storefront/orders/${item.id}`)}
                                                            >
                                                                #{item.order_number}
                                                            </button> 
                                                        </td>
                                                        <td>
                                                            {item?.user?.first_name+' '+item?.user?.last_name}
                                                        </td>
                                                        <td> {dateFormatter(item.created_at)}  </td>
                                                        <td>{formatCurrency(item.total).with_currency} </td>
                                                        <td>{formatCurrency(item.vat).with_currency} </td>
                                                        <td>{item.payment_method} </td>
                                                        <td>
                                                            <span className={`font-bold ${item.order_status === "open" ? "text-primary" : item.order_status === "settled" ? "text-success" : "text-danger"}`}>
                                                                {item.order_status}
                                                            </span> 
                                                        </td>
                                                        <td>{item.payment_status} </td>
                                                        <td className="d-flex m-0 align-items-center justify-content-between">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="border-0 bg-transparent" size="sm" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                </Dropdown.Toggle>
    
                                                                <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                    <Dropdown.Item 
                                                                        eventKey={1} 
                                                                        className="text-primary d-flex align-items-center gap-1" 
                                                                        onClick={() => navigate(user?.user_type === 'owner' ? `/storefront/orders/${item.id}` : `/members/storefront/orders/${item.id}`)}
                                                                    >
                                                                        <i className="lni lni-eye" style={{fontSize: "20px"}}></i>  View Items
                                                                    </Dropdown.Item>
                                                                    {
                                                                        item.order_status !== 'closed' && item.order_status !== 'settled' && item.order_status !== 'cancelled' ? (
                                                                            <>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item 
                                                                                    eventKey={2} 
                                                                                    className="text-primary d-flex align-items-center gap-1"
                                                                                    onClick={() => handleShowOrder(item)}
                                                                                >
                                                                                    <FontAwesomeIcon icon={'paper-plane'} /> Assign Department
                                                                                </Dropdown.Item>
                                                                            </>
                                                                        ) : null
                                                                    }
                                                                    {
                                                                        item.order_status === 'open' || item.order_status === 'PENDING' ? (
                                                                            <>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item 
                                                                                    eventKey={2} 
                                                                                    className="text-danger d-flex align-items-center gap-1"
                                                                                    onClick={(e) => orderManagement(item, 'cancelled')}
                                                                                >
                                                                                    <FontAwesomeIcon icon={'cancel'} /> Cancel Order
                                                                                </Dropdown.Item>
                                                                                {/* <Dropdown.Divider />
                                                                                <Dropdown.Item 
                                                                                    eventKey={2} 
                                                                                    className="text-danger d-flex align-items-center gap-1"
                                                                                    onClick={(e) => orderManagement(item, 'closed')}
                                                                                >
                                                                                    <FontAwesomeIcon icon={'times'} /> Close
                                                                                </Dropdown.Item> */}
                                                                            </>
                                                                        ) : null

                                                                    }
                                                                    {
                                                                        item.order_status === 'on-hold' || item.order_status === 'ON-HOLD' || item.order_status === 'open' ? (
                                                                            <>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item 
                                                                                    eventKey={2} 
                                                                                    className="text-success d-flex align-items-center gap-1"
                                                                                    onClick={(e) => orderManagement(item, 'settled')}
                                                                                >
                                                                                    <FontAwesomeIcon icon={'check'} /> Settle Order
                                                                                </Dropdown.Item>
                                                                            </>
                                                                        ) : null

                                                                    }
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item 
                                                                        eventKey={2} 
                                                                        className="text-primary d-flex align-items-center gap-1"
                                                                        onClick={() => handlePrint(item)}
                                                                    >
                                                                        <FontAwesomeIcon icon={'print'} /> Print Receipt
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item 
                                                                        eventKey={2} 
                                                                        className="text-primary d-flex align-items-center gap-1"
                                                                        onClick={() => handleDownload(item)}
                                                                    >
                                                                        <FontAwesomeIcon icon={'download'} /> Download
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))
                                            )
                                            : 
                                            (
                                                <tr>
                                                    <td colSpan={8} className="text-center text-muted">No data found</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                    {
                        state.orders?.length ? (
                            <div className="table-responsive mt-2">
                                <Paginator
                                    next={state.paginationData.next}
                                    prev={state.paginationData.prev}
                                    setCurrentPage={ handlePagination }
                                />
                            </div>
                        ) : null
                    }
                </div>
                <Modal 
                    onHide={() => setState((prevState) => ({...prevState, showOrder: false}))}
                    show={state.showOrder}
                    backdrop="static"
                    size="lg"
                >
                    <Modal.Header closeButton className="bg-primary text-white p-1">
                        <Modal.Title as={"h5"}>#{state.order?.order_number}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="table-responsive">
                        <p>Consumption Tax: {formatCurrency(state.order.consumption_tax).with_currency}</p>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Price(₦)</th>
                                    <th>Quantity</th>
                                    <th>Amount(₦)</th>
                                    <th>Unit/Department</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    state.order?.items && (
                                        state.order?.items.map((orderItem, index) => (
                                            <tr key={orderItem.id}>
                                                <td>{index+1}. {orderItem.product_name}</td>
                                                <td>{formatCurrency(orderItem.sales_price).formatted}</td>
                                                <td>{formatCurrency(orderItem.quantity).formatted}</td>
                                                <td>{formatCurrency(orderItem.quantity * orderItem.sales_price).formatted}</td>
                                                <td>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        defaultValue={state.orderAssignments[orderItem.id] || orderItem.department}
                                                        onChange={(e) => handleSelection(orderItem.id, e.target.value)}
                                                    >
                                                        <option value="">----</option>
                                                        {state.departments?.map((department) => (
                                                            <option key={department.id} value={department.name}>
                                                                {department.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                        ))
                                    )
                                }
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer className="p-1">
                        <Button 
                            type="button" 
                            variant="danger" 
                            className="text-white"
                            onClick={() => setState((prevState) => ({...prevState, showOrder: false}))}
                            >Close</Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            onClick={saveOrderChanges}
                            disabled={state.loading || Object.keys(state.orderAssignments).length === 0}
                        >Save Changes</Button>
                    </Modal.Footer>
                </Modal>

                {/* Departments */}
                <Modal 
                    onHide={() => setState((prevState) => ({...prevState, showDepartments: false}))}
                    show={state.showDepartments}
                    backdrop="static"
                    size="lg"
                >
                    <Modal.Header closeButton className="bg-primary text-white p-1">
                        <Modal.Title as={"h5"}>Units/Departments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Manager</th>
                                    <th>Email</th>
                                    <th>Phone Number</th>
                                    <th>Orders</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    state.departments && (
                                        state.departments.map((department, index) => (
                                            <tr key={department.id}>
                                                <td>{index+1}. {department.name}</td>
                                                <td>{department.manager}</td>
                                                <td>{department.email ?? '---'}</td>
                                                <td>{department.phone_number ?? '---'}</td>
                                                <td>
                                                    <button 
                                                        type="button"
                                                        className="btn-plain bg-primary text-white btn-sm rounded"
                                                        onClick={() => navigate(user?.user_type === 'owner' ? `/storefront/orders/daily-history?department=${department.name}` : `/members/storefront/orders/daily-history?department=${department.name}`)}
                                                    >
                                                        View Orders
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )
                                }
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer className="p-1">
                        <Button 
                            type="button" 
                            variant="danger" 
                            className="text-white"
                            onClick={() => setState((prevState) => ({...prevState, showDepartments: false}))}
                            >Close</Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </Layout>
    );
}

export default Orders;